// Matches the text-only row shimmer shared by PodcastAudios.js and AddContentToPodast.js —
// a title bar + subtitle bar, no thumbnail.
export default function TextRowListSkeleton({ rows = 4 }) {
    return (
        <div className="d-flex flex-column gap-3">
            {Array.from({ length: rows }).map((_, i) => (
                <div
                    key={i}
                    className="rounded-4 p-4"
                    style={{
                        background: 'rgba(var(--bs-primary-rgb),0.03)',
                        border: '1px solid rgba(var(--bs-primary-rgb),0.08)',
                    }}
                >
                    <div className="shine rounded-2 mb-2" style={{ height: 18, width: '55%' }} />
                    <div className="shine rounded-2" style={{ height: 14, width: '35%' }} />
                </div>
            ))}
        </div>
    );
}
